import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const IngredientGlossary = ({ ingredients }) => {
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="bg-card rounded-xl p-6 shadow-warm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="BookOpen" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="font-serif text-xl font-semibold text-foreground">
            Italian Ingredient Glossary
          </h3>
          <p className="text-sm text-muted-foreground">
            Learn about authentic Italian ingredients
          </p>
        </div>
      </div>
      <div className="space-y-3">
        {ingredients?.map((ingredient) => (
          <div
            key={ingredient?.id}
            className="border border-border rounded-lg overflow-hidden transition-all duration-300"
          >
            <button
              onClick={() => setExpandedId(expandedId === ingredient?.id ? null : ingredient?.id)}
              className="w-full flex items-center justify-between p-4 hover:bg-muted transition-colors duration-300"
            >
              <div className="flex items-center gap-3">
                <Icon name="Wheat" size={20} color="var(--color-primary)" />
                <div className="text-left">
                  <h4 className="font-medium text-foreground">{ingredient?.name}</h4>
                  <p className="text-sm text-muted-foreground italic">
                    {ingredient?.pronunciation}
                  </p>
                </div>
              </div>
              <Icon
                name={expandedId === ingredient?.id ? 'ChevronUp' : 'ChevronDown'}
                size={20}
                color="var(--color-muted-foreground)"
              />
            </button>

            {expandedId === ingredient?.id && (
              <div className="p-4 bg-muted/30 border-t border-border">
                <p className="text-sm text-foreground mb-3">{ingredient?.description}</p>
                <div className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Icon name="MapPin" size={16} className="flex-shrink-0 mt-0.5" />
                  <span>Origin: {ingredient?.origin}</span>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default IngredientGlossary;